import React, { useEffect, useRef, useState } from 'react';
import '../styles/foreground.css';
import logoImage from '../images/logo2-removebg-preview3.png';
import cuttyLogo from '../images/cuttyTextLogo.png';
import orbitTechLogo from '../images/OT_Server_Logo.gif';
import EightLogo from '../images/800GifLogo.gif';
import ethereumLogo from '../images/Ethereum_logo_2014.png';
import stableDiffusionLogo from '../images/StabilityAi_Logo.png';
import openAiLogo from '../images/OpenAI_Logo.png';
import fewtureLogo from '../images/fewture_co_logo.png';
import ndcLogo from '../images/NDCLOGO.png';
import uscLogo from '../images/USCLogo.png';
import cuttyImage1 from '../images/CuttyImage1.png';
import cuttyImage2 from '../images/CuttyImage2.png';
import cuttyImage3 from '../images/CuttyImage3.png';
import eightImage1 from '../images/800Image1.png';
import orbitTechGif from '../images/OrbitTechAccelerators.gif';

function Foreground() {
  const topIntroTextRef = useRef(null);
  const introTextRef = useRef(null);
  const projectsHeaderRef = useRef(null);
  const experienceHeaderRef = useRef(null);
  const educationHeaderRef = useRef(null);
  const [blur, setBlur] = useState(false);


  useEffect(() => {
    const observerOptions = {
      root: null, // observes elements in the document viewport
      rootMargin: '0px',
      threshold: 0.1 // triggers when at least 10% of the observed element is visible
    };

    const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setBlur(false); 
          entry.target.classList.add('fadeInUp');
        } else {
          setBlur(true);
          entry.target.classList.remove('fadeInUp');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    if (topIntroTextRef.current) {
        observer.observe(topIntroTextRef.current);
    }
    if (introTextRef.current) {
        observer.observe(introTextRef.current);
    }
    if (projectsHeaderRef.current) {
        observer.observe(projectsHeaderRef.current);
    }
    if (experienceHeaderRef.current) {
      observer.observe(experienceHeaderRef.current);
    }
    if (educationHeaderRef.current) {
      observer.observe(educationHeaderRef.current);
    }


    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className='foreground-container'>
        <div className='top-intro'>
          <img src={logoImage} alt="ASLogo" className="top-left-image" />
          <header ref={topIntroTextRef} className='top-intro-text'><span className='top-intro-bold'>Adam Sanfacon <br></br></span><span className='top-intro-light'>Full Stack Software Developer</span></header>
          <p ref={introTextRef} className='intro-text'>Hello! I am a 23 year old web/UI developer, software engineer, blockchain enthusiast, and AI hobbyist. I currently do both front-end and back-end development.</p>
        </div>
        <div className='projects-info'>
          <header ref={projectsHeaderRef} className='project-header'>MY PROJECTS</header>

          <img src={cuttyLogo} className='cutty-logo'></img>
          <img src={cuttyImage1} className='cutty-image1'></img>
          <img src={cuttyImage2} className='cutty-image2'></img>
          <img src={cuttyImage3} className='cutty-image3'></img>

          <header className='cutty-header'><a className='cutty-link' href="https://www.cutty.xyz">www.cutty.xyz</a></header>
          <p className='cutty-info'>A React webapp facilitating user promotions through digital geocaching using geolocation+Leaflet, a built-in QR scanner, and Firebase. Developed for a retail chain in Los Angeles. This webapp has had hundreds of daily active users during events, and is continuously updated. I led development and am the primary contributor to this project.</p>
          
          <header className='eight-header'>Real Estate Ethereum Project</header>
          <img src={EightLogo} className='eight-logo'></img>
          <img src={eightImage1} className='eight-image'></img>
          <p className='eight-info'>A completely novel legally-binding Ethereum smart contract standard to represent real estate property along with a dynamic React website showcasing the land. The project features a Nextjs user portal integrated with Web3js for smart contract interactions and personalized contract connections. Completed in a team of three developers, I was responsible for overseeing and contributing to both contract development and website development.</p>
          
          <header className='ot-header'>Orbit Technologies</header>
          <img src={orbitTechLogo} className='orbit-tech-logo'></img>
          <img src={orbitTechGif} className='orbit-tech-gif'></img>
          <p className='orbit-tech-info'>An ERC-721 Ethereum token collection with accompanying React website and unique 3D art made in Cinema4D. I assisted in much of the contract and website development, token metadata management and Cinema4D art rendering generation. This project was created alongside 2 other developers.</p>

          <header className='eth-header'>Bitcoin Miner and MEV projects</header>
          <img src={ethereumLogo} className='ethereum-logo'></img>
          <p className='eth-info'>As a hobby, I mined Ethereum for over 2 years from 2016-2018 with a number of home rigs. As an additional project, I also created a Solidity and Typescript trading bot on the Arbitrum network to extract value from price differentials between different decentralized exchanges.</p>
        
          <header className='stableDiff-header'>AI Finetuning and API projects</header>
          <img src={stableDiffusionLogo} className='stableDiff-logo'></img>
          <img src={openAiLogo} className='openAI-logo'></img>
          <p className='stableDiff-info'>As an additional personal project, I worked with an artist to fine-tune a StableDiffusion model using KohyaSS based on his artwork. I have also garnered a serious interest in working with multiple APIs from prominent AI companies, as well as locally hosting a LLaMA model. Among these was a project wherein I contributed to a repository that allows GPT-4 to store long term memory from all past conversations.</p>
        </div>

        <div className='experience-info'>
          <header ref={experienceHeaderRef} className='experience-header'>MY EXPERIENCE/RESUME</header>
          <img src={fewtureLogo} className='fewture-logo'></img>
          <header className='fewture-header'>Fewture Co - Aug 2022-present</header>
          <header className='fewture-subheader'>Software Engineer</header>
          <p className='fewture-info'>• Collaborating with a startup team to conceptualize and execute various software solutions tailored to diverse client needs, as well as internal product and software development.<br></br>
            • Currently spearheading the development of products for customers including full stack website/app development, AI model fine-tuning, blockchain development, and 3D engine tooling (Unreal Engine 5, Cinema 4D).<br></br>
            • As a lead developer, successfully managed and created multiple web applications; a prominent project includes a production full stack TypeScript React platform (Cutty) for a retail chain, facilitating user promotions via digital geocaching service. The project is in development following the CI/CD pipeline and currently has hundreds of active users.<br></br>
            • Utilizing a variety of services to build out software development initiatives, including AWS services, Firebase, React, Next.js, Vue, Vercel, GitHub and a number of other front and backend libraries and tools.<br></br>
            • Contributed to and managed a team of three developers to create a novel legally-binding Ethereum smart contract standard to represent a Bel Air real estate property along with a dynamic React website showcasing the land. The project features a Nextjs user portal integrated with Web3js for smart contract interactions and personalized contract connections.<br></br>
            • Engaged in the advanced customization (Python and Java) of AI models, notably StableDiffusion and DiscoDiffusion, to empower clients in enhancing their artistic capabilities (KohyaSS and Google Colab).
          </p>

          <img src={ndcLogo} className='ndc-logo'></img>
          <header className='ndc-header'>National Datacare - June 2021-present</header>
          <header className='ndc-subheader'>Software Engineer (Part-time)</header>
          <p className='ndc-info'>• Assisted in handling company SQL databases, and gained proficiency with queries and relations; worked with database manager to update disaster recovery plans.<br></br>
            • Created production tooling utilizing various shipping service APIs (FedEx and UPS) in C# for users to calculate and pay shipping costs more accurately (SOAP and REST), developed following Agile framework.<br></br>
            • Developed web scraping applications using Python and Selenium to efficiently and autonomously gather all statement data for clients from prominent banks’ large-scale business treasury management services.<br></br>
          </p>

          <img src={orbitTechLogo} className='orbit-tech-logo2'></img>
          <header className='ot-header2'>Orbit Technologies - Oct 2021-Dec 2022</header>
          <header className='ot-subheader'>Software Engineer</header>
          <p className='ot-info2'>• Worked with a team of 5 to create an Ethereum smart contract and accompanying dynamic React website<br></br>
            • Led the development of smart contracts used on Ethereum using Solidity and effectively managed project backend<br></br>
            • Managed the automation process of 3D artistic renders used in the project using Python, Cinema4D and cloud computing<br></br>
          </p>

          <header className='skills-header'>SKILLS/CERTIFICATIONS</header>
          <p className='skills-info'>
            <span className='skills-bold-certif'>Certifications:</span> CompTIA Security+ <br></br>
            <span className='skills-bold'>Languages:</span> Proficiency in Java, JavaScript, TypeScript, Python, Solidity, C++, and HTML/CSS; familiar with SQL, Cadence, Prolog, Haskell, R, and C#.<br></br>
            <span className='skills-bold'>Operating Systems:</span> Proficiency in Windows and Linux systems/Bash, familiar with macOS.<br></br>
            <span className='skills-bold'>Libraries and Frameworks:</span> Node, React, Angular, Three.js, React Native, Ethers, Next.js, Vercel, Spring and more.<br></br>
            • Experienced in a number of 3D modelling software tools such as Cinema4D, Blender and Unreal Engine 5 <br></br>
            • Experienced in the modification, diagnosis and repair of hardware, including custom electrical engineering projects.<br></br>
            • Proficient in the utilization of artificial intelligence tooling to optimize workflow and increase productivity.<br></br>
            • Engaged in several AI-related projects garnering familiarity in tools like PyTorch, TensorFlow, and various APIs.<br></br>
          </p>
        </div>

        <div className='education-and-info'>
          <header ref={educationHeaderRef} className='information-header'>Education and Personal Info</header>
          <img src={uscLogo} className='university-logo'></img>
          <header className='information-subheader'>Bachelor's of Science in Computer Science</header>
          <header className='capstone-project-header'>August 2019-May 2023 (Cum Laude)</header>
          <p className='information-text'>My name is Adam Sanfacon, I am a software developer with experience primarily in the startup space; I have had a passion for artificial intelligence, cybersecurity and cryptocurrency since my youth. I studied and received my bachelors of Computer Science at the University of South Carolina in May 2023 and graduated Cum Laude (GPA {'>'} 3.0). I was a Capstone scholar and was involved in multiple long-term software development projects as a result. During my time at university, I was involved in multiple startups, and garnered invaluable skills that would come to assist me further in my professional life.</p>
          <header className='capstone-project-header'>Capstone Scholar: Capstone Projects</header>
          <p className='capstone-information'>• Created a student/teacher full-stack web application in React with 3 other students, acting as a hub for classes, grades, & assignments. Users could sign up as either students or professors, and would be allowed permissions based on their role, such as creating classes, joining classes, editing or viewing grades, and uploading assignments.<br></br>
            • Developed a full stack Java interface with 3 other students over the course of a year, showcasing understanding of various design patterns and multithreading capabilities within Java.
          </p>
        </div>

        <div className='contact-info'>
          <header className='contact-header'>CONTACT</header>
          <p className='contact-text'>I can be reached through the following sources: <br></br><br></br>adamsanfacon@gmail.com <br></br>+1 (703)-963-5053</p>
        </div>
    </div>
  );
}

export default Foreground;
